export default {
    leftPanel: {
        btnImport: 'Importer',
        btnAppointments: 'Rendez-vous',
        btnHistory: 'Historique',
        btnAutomations: 'Automatisations',
        statistics: 'Statistiques',
        confirmed: 'Confirmé | Confirmés',
        notConfirmed: 'Non Confirmé | Non Confirmés',
        canceled: 'Annulé | Annulés',
    },
    appointmentsList: {
        allTab: 'Tous',
        appointmentExcluded: 'Les règles d\'exclusion d\'une automatisation peuvent empêcher l\'envoi automatique d\'une confirmation pour ce rendez-vous',
        bulkAction: 'Actions de masse',
        canceledTab: 'Annulés',
        sentStatus: "Statut d'envoi",
        confirmedTab: 'Confirmés',
        contactUnsubscribed: 'Le contact est désabonné',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression de rendez-vous',
            message: 'Voulez-vous vraiment supprimer les rendez-vous sélectionnés?',
        },
        email: 'Courriel',
        markCanceled: 'Marquer Annulé',
        markConfirmed: 'Marquer Confirmé',
        markNotConfirmed: 'Marquer Non confirmé',
        name: 'Contact',
        noAppointments: 'Aucun rendez-vous.',
        wouldYouLikeToAddOne: 'Voulez-vous en ajouter?',
        notConfirmedTab: 'Non confirmés',
        notSent: 'Non Envoyée',
        pageTitle: 'Rendez-vous',
        phone: 'Téléphone',
        search: 'Rechercher...',
        sendAppointmentUpdatedSmsModal: {
            header: 'Notification SMS',
            message: 'Voulez-vous envoyer un SMS avec le nouveau statut du rendez-vous au client?',
        },
        sendEmailConfirmation: 'Confirmation par courriel',
        sendSmsConfirmation: 'Confirmation par SMS',
        status: 'Statut',
        time: 'Heure',
        actions: 'Actions',
    },
    appointmentModal: {
        addTitle: 'Nouveau rendez-vous',
        appointmentCreated: 'Le rendez-vous a été créé avec succès.',
        appointmentUpdated: 'Le rendez-vous a été modifié avec succès.',
        contact: 'Contact',
        date: 'Date',
        editTitle: 'Modification de rendez-vous',
        notes: 'Notes',
        relatedVehicleMake: 'Marque du véhicule associé',
        selectDate: 'Choisissez une date...',
        selectTime: 'Choisissez une heure...',
        time: 'Heure',
    },
    sendConfirmationModal: {
        titleSms: 'Envoi de confirmation par SMS',
        titleEmail: 'Envoi de confirmation par courriel',
        templateCategory: 'Catégorie de messages prédéfinis',
        template: 'Message prédéfini',
        preview: 'Aperçu',
        previousBtn: 'Message précédent',
        nextBtn: 'Message suivant',
        placeholders: 'Attributs',
        cancel: 'Annuler',
        sending: 'L\'envoi des confirmations est en cours...',
        sendingFailed: 'Une erreur s\'est produite lors de l\'envoi des confirmations',
    },
    importHistory: {
        actions: 'Actions',
        all: 'Tous',
        completed: 'Complétés',
        date: 'Date',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression d\'import',
            message: 'Voulez-vous vraiment supprimer l\'import?<br>Toutes les données associées seront supprimées.',
        },
        failed: 'Échoués',
        filename: 'Nom du fichier',
        noImports: 'Aucun import.',
        notCompleted: 'Non Complétés',
        pageTitle: 'Historique',
        search: 'Rechercher...',
        status: 'Statut',
        statusCompleted: 'Complété',
        statusFailed: 'Échoué',
        statusUncompleted: 'Non Complété',
        type: 'Type',
        types: {
            appointment: 'Rendez-vous',
            campaign: 'Campagne',
            contact: 'Contact',
        },
        user: 'Utilisateur',
        viewResult: 'Voir résultat',
        comingSoon: 'Fonctionnalité disponible sous peu',
    },
    importResult: {
        pageTitle: 'Résultat d\'importation',
        noAppointmentsImported: 'Aucun rendez-vous importé.',
    },
    automationsList: {
        add: 'Ajouter une automatisation',
        allTab: 'Tout',
        bulkAction: 'Actions de masse',
        delete: 'Supprimer',
        deleteModal: {
            header: 'Suppression d\'automatisations',
            message: 'Voulez-vous vraiment supprimer les automatisations sélectionnées?',
        },
        name: 'Nom',
        pageTitle: 'Automatisations',
        pause: 'Arrêter',
        paused: 'Arrêtée',
        pausedTab: 'Arrêtées',
        run: 'Activer',
        running: 'Activé',
        runningTab: 'Activés',
        toAddAutomation: 'pour ajouter une automatisation',
    },
    automationModal: {
        title: 'Automatisation',
        name: 'Nom',
        what: 'Quoi',
        when: 'Quand',
        same: 'Même',
        hour: 'heure | heures',
        day: 'jour | jours',
        before: 'avant',
        whenWillMessageBeSent: 'Quand le message sera-t-il envoyé?',
        timeHeader: 'Heure',
        dayHeader: 'Jour',
        whenAutomationActive: 'Quand cette automatisation est-elle active?',
        successMessage: 'Votre automatisation a été créé avec succès.',
        updateMessage: 'Votre automatisation a été modifiée avec succès.',
    },
};
